// src/pages/gears/Neo.js

import "../../App.css";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import BackOnly from "../../components/BackOnly";
import ContactPopup from "../../components/ContactPopup";
import AffiliateAmazon from "../../components/affiliate/AffiliateAmazon";
import AffiliateEbay from "../../components/affiliate/AffiliateEbay";
import React, { useState } from "react";

// ⭐ IMPORT ONLY THE IMAGES YOU NEED
import droneImg from "./gearimages/mavicpro2.jpg";

export default function MavicPro() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Header />

      <div className="visited-back-wrapper">
        <BackOnly />
      </div>

      <div className="page-container" style={{ padding: "10px" }}>
        <section className="gear-review">

          {/* ⭐ NEW GEAR LAYOUT */}
          <div className="gear-container">

            {/* LEFT COLUMN */}
            <div className="gear-left">
              <h1>DJI Mavic Pro 2</h1>

              <p>
                The DJI Mavic Pro 2 is a professional‑grade drone packed into a compact,
                foldable design. Its 20MP Hasselblad camera with a 1‑inch CMOS sensor
                delivers stunning 4K footage with excellent dynamic range, making it a
                favorite among travelers, filmmakers, and aerial photographers.
              </p>

              <p>
                With 31 minutes of flight time, omnidirectional obstacle sensing, and
                intelligent flight modes like ActiveTrack 2.0 and Hyperlapse, the Mavic
                Pro 2 offers both safety and creative flexibility. OcuSync 2.0 provides
                a strong 1080p video transmission up to 8 km, ensuring reliable control
                even in challenging environments.
              </p>

              <div className="place-block">
                <ul>
                  <li>20MP Hasselblad camera with 1-inch CMOS sensor</li>
                  <li>4K video at 30fps with 10-bit Dlog-M</li>
                  <li>Adjustable aperture f/2.8–f/11</li>
                  <li>31 minutes of flight time</li>
                  <li>8 km (5 mi) 1080p transmission with OcuSync 2.0</li>
                  <li>360° omnidirectional obstacle sensing</li>
                  <li>ActiveTrack 2.0 + Hyperlapse modes</li>
                  <li>Foldable, portable design</li>
                  <li>Compatible with DJI GO 4 app and RC controller</li>
                </ul>

                <p>
                  <strong>Important notes about drone regulations in the United States:</strong>
                  <br /><br />
                  • All drones over 0.55 lbs (250g) must be registered with the FAA.
                  <br />
                  • Recreational flyers must pass the TRUST test and carry proof.
                  <br />
                  • Commercial pilots must follow FAA Part 107 rules.
                  <br />
                  • Remote ID is now required for most drones operating outdoors in the U.S.
                  <br />
                  • Older drones without built‑in Remote ID must use an approved broadcast module.
                  <br />
                  • Some discontinued drones are no longer legal to fly without Remote ID compliance.
                  <br />
                  • Always check airspace restrictions using apps like B4UFLY or Aloft.
                  <br /><br />
                  <strong>Note:</strong> The DJI Mavic Pro 2 does <em>not</em> include built‑in Remote ID.
                  To fly legally in the U.S., you must attach an FAA‑approved Remote ID broadcast module.
                </p>
              </div>

              <AffiliateAmazon
                title="Check price on Amazon"
                link="https://amzn.to/47Q8pyY"
              />

              <AffiliateEbay
              title="Check price on eBay"
                link="https://www.ebay.com/sch/i.html?_nkw=DJI+Mavic+Pro+2&_sacat=0&_from=R40&_sop=12"
              />
            </div>

            {/* RIGHT COLUMN */}
            <div className="gear-right">
              <img src={droneImg} alt="DJI Mavic Pro 2" />
            </div>

          </div>
        </section>
      </div>

      <div className="email-wrapper">
        <button className="email-link" onClick={() => setOpen(true)}>
          contact@thefindingspot.com
        </button>
      </div>

      <ContactPopup isOpen={open} onClose={() => setOpen(false)} />

      <Footer />
    </>
  );
}
